export default {
  options: {},
  inhabitantChangeStatuses: [],
};
